// Loads the correct Authorize.Net Accept.js for the active environment.
// Sandbox creds must tokenize against jstest.authorize.net; production creds
// against js.authorize.net. Injected on demand (the static tag was removed from
// index.html) so one build works in dev and prod, driven by the `environment`
// field on the payment intent (backend AUTHNET_ENV).

type AuthnetEnv = 'sandbox' | 'production';

let loadPromise: Promise<void> | null = null;
let loadedEnv: AuthnetEnv | null = null;

export function ensureAcceptJs(env?: AuthnetEnv): Promise<void> {
  const target: AuthnetEnv = env === 'sandbox' ? 'sandbox' : 'production';

  if (loadedEnv === target && loadPromise) {
    return loadPromise;
  }

  loadedEnv = target;
  loadPromise = new Promise<void>((resolve, reject) => {
    const src =
      target === 'sandbox'
        ? 'https://jstest.authorize.net/v1/Accept.js'
        : 'https://js.authorize.net/v1/Accept.js';

    const existing = document.querySelector<HTMLScriptElement>(
      `script[data-acceptjs="${target}"]`
    );
    if (existing) {
      if (window.Accept) {
        resolve();
      } else {
        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', () =>
          reject(new Error('Failed to load Accept.js'))
        );
      }
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.setAttribute('charset', 'utf-8');
    script.setAttribute('data-acceptjs', target);
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Accept.js'));
    document.head.appendChild(script);
  });

  return loadPromise;
}
